import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import usePagination from 'hooks/usePagination';
import BuildChildren from 'utils/BuildChildren';
import PaginationA from 'components/Pagination/PaginationA';
import classNames from 'classnames';
import classes from './CardListD.module.scss';

const CardListD = (props) => {
  const {
    items: listOfItems = [],
    itemIncrement = 10,
    divided = false,
    displayOptions = {},
  } = props;

  const [items, setItems] = useState(listOfItems);
  const [activePage, setActivePage] = useState(1);
  const containerRef = useRef(null);

  useEffect(() => {
    setItems(listOfItems);
    setActivePage(1);
  }, [
    listOfItems,
    setItems,
  ]);

  const {
    itemsOnPage,
    pageCount,
  } = usePagination({ items, page: activePage, itemsPerPage: itemIncrement });

  const displayedItems = itemsOnPage;
  const isSingleView = listOfItems.length === 1;

  return (
    <div className={classes.container} ref={containerRef}>
      <div className={classes.itemsContainer}>
        {items.map((item, i) => (
          <div
            className={classNames(
              divided ? classes.itemDivided : classes.item,
              !displayedItems.includes(item) && classes.hide,
            )}
            key={`${item.type}-${i}`}
          >
            {BuildChildren({ ...item, ...displayOptions })}
          </div>
        ))}
      </div>
      {
        !isSingleView && (
          <PaginationA
            containerRef={containerRef}
            pageCount={pageCount}
            setActivePage={setActivePage}
            activePage={activePage}
          />
        )
      }
    </div>
  );
};

CardListD.propTypes = {
  items: PropTypes.array, // items in list
  itemIncrement: PropTypes.number, // number of items to display at a time
  divided: PropTypes.bool, // divider lines between items
  displayOptions: PropTypes.object, // data that is used to customize labels
};

export default CardListD;
